const styles = theme => ({
  // --- NEW: bölümler arası düzenli boşluk
  section: {
    width: '100%',
    marginBottom: 24,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 16,
    },
  },

  // Uyarı metni
  warningText: {
    color: '#FF0000',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginLeft: 10,
  },

  // Private key alanı
  privateKeyContainer: {
    marginTop: 16,
    width: '100%',
  },
  privateKeyWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 12,
    },
  },
  copyIconBtn: {
    alignSelf: 'center',
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'flex-end',
    },
  },

  // Başlık
  title: {
    backgroundColor: '#F9F9F9',
    height: 100,
    textAlign: 'center',
    textPadding: 'center',
  },

  // Form alanları – mobilde tek kolon
  textValidator: {
    width: '50%',
    marginBottom: '3%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12,
    },
  },
  textField: { width: '100%' },
  muTextValidator: { width: '100%' },

  positionEnd: { marginLeft: '-12%' },
  inputStyle: { display: 'none !important' },

  p: { fontSize: 14, fontWeight: 600 },
  div: { margin: '0 0 20px' },

  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },

  // Kaydet / Add butonu – mobilde tam genişlik
  btnSubmit: {
    width: '20%',
    height: 50,
    borderRadius: 28.8,
    backgroundColor: '#0f1120',
    marginLeft: '1%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
    },
  },
  txtRefreshToken: {
    fontFamily: 'Gilroy-Light',
    color: '#fff',
    textTransform: 'uppercase',
  },
  label: { fontSize: 14 },

  buttonProgress: {
    color: '#008000',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },

  // Liste öğeleri (değiştirmedik)
  listItem: {
    boxShadow: '0 1px 2px 0 #647385',
    backgroundColor: '#fff',
    margin: '2%',
    height: 87,
  },
  listItemText: { fontSize: 12, fontWeight: 900, width: '80%' },
  secondaryAction: { marginRight: -57 },

  header: {
    width: 167,
    height: 26,
    fontFamily: 'Gilroy-Light',
    fontSize: 20,
    fontWeight: 900,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '-0.7px',
    color: '#0f1120',
    marginBottom: '2%',
  },
  appType: { fontSize: 26, fontWeight: 900 },

  // Eski token yenile butonu (dokunmadım)
  btnRefreshToken: {
    width: 153,
    height: 50,
    borderRadius: 28.8,
    backgroundColor: '#0f1120',
    marginLeft: '1%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      marginTop: 8,
    },
  },

  colorSwitchBase: {
    color: '#fff',
    '&$colorChecked': {
      color: '#50e3c2',
      '& + $colorBar': { backgroundColor: '#50e3c2' },
    },
  },
  colorBar: {},
  colorChecked: {},

  avatar: { width: 140, height: 140 },

  // OTP satırı – mobilde kırılmasın
  otpRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flexWrap: 'wrap',
    margin: '8px 0 16px',
  },

  // Aksiyon alanı
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 8,
    },
  },
    /* === Sadece mobil için AppIcon satırı düzeni === */
  appIconMobileFix: {
    [theme.breakpoints.down('sm')]: {
      display: 'grid !important',         // inline display:flex'i mobilde geçersiz kıl
      gridTemplateColumns: '1fr',
      alignItems: 'start',
      rowGap: 12,
      width: '100%',
    },
  },

  /* Orta sütun (butonlar) – mobilde paddingi sıfırla ve sar */
  appIconButtonsMobile: {
    [theme.breakpoints.down('sm')]: {
      padding: '0 !important',            // inline padding: 0px 30px'i override et
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
      flexDirection: 'row',
    },
  },

  /* Sağdaki bilgilendirme metni – mobilde tam genişlik & normal sarım */
  iconLimitText: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      marginLeft: 0,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      lineHeight: 1.4,
    },
  },

});

export default styles;
